import * as React from "react";
import { SetStateAction, Dispatch, } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputDate } from 'src/components/common/PbrInputDate/PbrInputDate';
import * as moment from 'moment';
import { IPrecatorioCalculator } from "src/services/interfaces/calculator/IPrecatorioCalculator";
import { IPrecatorio } from "src/services/interfaces/IPrecatorio";

interface IIssueDateComponent {
  customClass?: string
  request: IPrecatorioCalculator | IPrecatorio;
  onChange: Dispatch<SetStateAction<Partial<IPrecatorioCalculator>>>;
  disabled?: boolean
}

export function IssueDateComponent(props: IIssueDateComponent & FormComponentProps) {

  return (
    <PbrInputDate
      disabled={props.disabled}
      className={props.customClass}
      name="issueDate"
      formWrapper={props.form}
      formItemProps={{ label: "Data de Expedição" }}
      placeholder="Data de Expedição"
      value={moment(props.request.issueDate)}
      onChange={e => props.onChange({ issueDate: moment(e) })}
      rules={[{ required: true, message: "Data de Expedição é obrigatória" }]}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/IssueDateComponent/IssueDateComponent.tsx